import { render, staticRenderFns } from "./Membre.vue?vue&type=template&id=87f97b1a&scoped=true&"
import script from "./Membre.vue?vue&type=script&lang=js&"
export * from "./Membre.vue?vue&type=script&lang=js&"
import style0 from "./Membre.vue?vue&type=style&index=0&id=87f97b1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f97b1a",
  null
  
)

export default component.exports